module.exports = __webpack_public_path__ + "img/display-pos1.aa39ec60.png";